import {
  REFRESH_TOKEN_GUEST_STORAGE_KEY,
  REFRESH_TOKEN_REGISTERED_STORAGE_KEY,
  TOKEN_STORAGE_KEY,
} from '@susu/headless-commerce/libs/sfcc/constants'
import type { CountryConfiguration } from '@susu/headless-commerce/types/CountryConfiguration'
import { getCookie } from '@susu/cookie'

export const getToken = () => getCookie(TOKEN_STORAGE_KEY)

export const getRefreshToken = (country: CountryConfiguration) =>
  getCookie(REFRESH_TOKEN_REGISTERED_STORAGE_KEY(country.siteID)) ??
  getCookie(REFRESH_TOKEN_GUEST_STORAGE_KEY(country.siteID))

export const setLastVisitedLocaleCookie = async (cookieCountryCode: string) => {
  return fetch('/api/location/last-visited-locale', {
    method: 'POST',
    headers: {
      'x-headless': 'true',
    },
    body: JSON.stringify({
      cookieCountryCode,
    }),
  })
}

export const setDenyCountrySwitchCookie = async (
  localeCountry: string,
  cookieCountry: string,
  unsupported = false,
) => {
  return fetch('/api/location/deny-country-switch', {
    method: 'POST',
    headers: {
      'x-headless': 'true',
    },
    body: JSON.stringify({
      localeCountry,
      cookieCountry,
      unsupported,
    }),
  })
}
